import React from 'react';
import { InfoCard } from '@backstage/core-components';
import { Button, Typography } from '@material-ui/core';

import { useOpenInCoderLink } from '../plugin';
import { DEFAULT_CODER_DOCS_LINK } from '../typesConstants';
import { OpenInCoderButton } from './OpenInCoderButton';

type Props = {
  coderAccessUrl: string;
  coderDocsLink?: string;
};

// ExampleContributingCard Component
export const CoderContributingCard = ({
  coderAccessUrl,
  coderDocsLink = DEFAULT_CODER_DOCS_LINK,
}: Props) => {
  const link = useOpenInCoderLink(coderAccessUrl);

  return (
    <InfoCard title="Contributing">
      {link ? (
        <>
          <Typography variant="body1" style={{ marginBottom: '16px' }}>
            This workspace has a Coder template. Create a cloud development
            environment with all the tools you need:
          </Typography>

          <OpenInCoderButton
            coderAccessUrl={coderAccessUrl}
            coderDocsLink={coderDocsLink}
          />
        </>
      ) : (
        <>
          <Typography variant="body1" style={{ marginBottom: '16px' }}>
            This service has not been configured with a Coder template. Refer to
            the git repository for manual contribution instructions.
          </Typography>

          <Button
            component="a"
            variant="contained"
            color="primary"
            href={coderDocsLink}
            target="_blank"
          >
            Learn More
          </Button>
        </>
      )}
    </InfoCard>
  );
};
